import { useCallback, useState } from "react";
import { useLocalStorage } from "usehooks-ts";

import { REVIEW_TYPES } from "features/cdm/constants/reviewTypes";

// The PP "add review" flow: the dialog open state + pending review type, the
// patient's locally-added PP reviews, and the handler that adds one (flagging an
// annual review from the pending type) and asks the caller to open its preview.
export const usePpReview = ({
  patientId,
  onReviewAdded,
  onReviewRemoved,
}) => {
  const [isAddPpReviewDialogOpen, setIsAddPpReviewDialogOpen] = useState(false);
  const [pendingPpReviewType, setPendingPpReviewType] = useState(
    REVIEW_TYPES.PP_REGISTRATION
  );
  const [temporaryPp, setTemporaryPp] = useLocalStorage(
    `kinesin-temporary-pp-${patientId}`,
    []
  );

  const openPpReviewDialog = useCallback((reviewType) => {
    setPendingPpReviewType(reviewType);
    setIsAddPpReviewDialogOpen(true);
  }, []);

  const addPpReview = useCallback(
    (data) => {
      setTemporaryPp((prev) => [
        ...prev,
        {
          ...data,
          isAnnualReview: pendingPpReviewType === REVIEW_TYPES.PP_ANNUAL,
        },
      ]);
      onReviewAdded?.(data.id);
    },
    [setTemporaryPp, onReviewAdded, pendingPpReviewType]
  );

  const removePpReview = useCallback(
    (reviewId) => {
      setTemporaryPp((prev) => prev.filter((item) => item.id !== reviewId));
      onReviewRemoved?.();
    },
    [setTemporaryPp, onReviewRemoved]
  );

  return {
    temporaryPp,
    isAddPpReviewDialogOpen,
    setIsAddPpReviewDialogOpen,
    pendingPpReviewType,
    openPpReviewDialog,
    addPpReview,
    removePpReview,
  };
};
